import { render, staticRenderFns } from "./LanguageClasses.vue?vue&type=template&id=60ecb2e5&scoped=true&"
import script from "./LanguageClasses.vue?vue&type=script&lang=js&"
export * from "./LanguageClasses.vue?vue&type=script&lang=js&"
import style0 from "./LanguageClasses.vue?vue&type=style&index=0&id=60ecb2e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ecb2e5",
  null
  
)

export default component.exports